/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, BOURBON){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const h = 'is-hidden';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left2" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right2" /></svg></button>'
	const $map = location.pathname;


	// <サイドナビ>小カテゴリ取得用
	const getJSONcategory = () => {
		return $.getJSON('/ajax/product/category.json');
	};
	// <サイドナビ>ブランド取得用
	const getJSONbrand = () => {
		return $.getJSON('/ajax/product/brand.json');
	};
	// <サイドナビ>シーン取得用
	const getJSONscene = () => {
		return $.getJSON('/ajax/product/scene.json');
	};
	// <商品詳細>大カテゴリ商品取得用
	const getJSONcategoryProdList = (_category) => {
		return $.getJSON(`/ajax/detail/category_l/${_category}.json`);
	};
	// <商品詳細>ブランド商品取得用
	const getJSONbrandProdList = (_brand) => {
		return $.getJSON(`/ajax/detail/brand/${_brand}.json`);
	};
	// <お気に入りページ>商品情報取得用
	const getJSONprodData = (_id) => {
		return $.getJSON(`/ajax/product/detail/${_id}.json`);
	};

	// 新商品スライド
	const newProductsSlider = () => {
		$('.prod-idx-newProd-slider').slick({
			infinite: true,
			speed: 1500,
			autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 5,
			swipeToSlide: true,
			arrows: false,
			dots: false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					}
				}
			]
		});
	}
	// ブランドバナースライド
	const brandSlider = () => {
		$('.prod-idx-brand-slider').slick({
			infinite: true,
			speed: 1500,
			autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 3,
			arrows: true,
			dots: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					}
				}
			]
		});
	}
	// キャンペーンバナースライド
	const campaignSlider = () => {
		$('.prod-idx-campaign-slider').slick({
			infinite: true,
			speed: 1500,
			autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 3,
			arrows: true,
			dots: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	}

	// <商品検索>
	const prodMenu = () => {
		const $menuBlock = $('.js-prodMenuBlock');
		let scrollTopNow;
		let widthFlag = '';

		const widthCheck = () => {
			let winWidth = $(window).width();
			if(winWidth <= BOURBON.va.device.desktop && widthFlag != 'sp') {
				// SP処理
				widthFlag = 'sp';
				if($('.mod-sideNav-nav').hasClass(a)) {
					fixedOnContainer();
				}
			} else if(winWidth > BOURBON.va.device.desktop && widthFlag != 'pc') {
				// PC処理;
				widthFlag = 'pc';
				fixedOffContainer();
			}
		}
		const fixedOnContainer = () => {
			scrollTopNow = $(window).scrollTop();
			$('.container').css({
				position: 'fixed',
				width: '100%',
				top: -1 * scrollTopNow,
				left: 0
			});
			$('body').addClass(f);
		};
		const fixedOffContainer = () => {
			$('.container').css({
				position: 'static'
			});
			$('body').removeClass(f);
			$(window).scrollTop(scrollTopNow);
		};

		$(window).on('resize', () => {
			widthCheck();
		}).resize();


		// 商品検索ブロック開閉
		$('.js-prodMenu-open').on('click', (e) => {
			$(e.currentTarget).addClass(h);
			$menuBlock.addClass(a);
			if(widthFlag === 'sp') {
				fixedOnContainer();
			}
		});
		$('.js-prodMenu-close').on('click', (e) => {
			$menuBlock.removeClass(a);
			$('.js-prodMenu-open').removeClass(h);
			if(widthFlag === 'sp') {
				fixedOffContainer();
			}
		});
		$('.prod-menuBlock-head._sub').on('click', (e) => {
			$(e.currentTarget).toggleClass(a);
			$(e.currentTarget).next('.prod-menuBlock-subList').slideToggle();
		});
	};

	// <サイドナビ>
	const sideNav = () => {
		// カテゴリリスト生成
		getJSONcategory().then((data) => {
			// 「●●すべて」
			if (data.rt_bn_product_category_list.length) {
				let catData = data.rt_bn_product_category_list;
				for(let i = 0; i < catData.length; i++) {
					let thisData = catData[i];
					let thisParentsCat = thisData.cf_pc_group_code;
					let thisHref = thisData.rt_cf_pc_href.href;
					let thisName = thisData.cf_pc_name;
					let allHref = catData[i].rt_cf_pc_l_href.href;
					let currentClass = '';

					if($map.indexOf(thisHref) !== -1) {
						currentClass = a;
						$(`.js-categoryList[data-cat="${thisParentsCat}"]`).prev('.prod-menuBlock-head').addClass(a);
						$(`.js-categoryList[data-cat="${thisParentsCat}"]`).slideDown();
					}
					let thisHTML = `<li class="prod-menuBlock-subList-li"><a href="${thisHref}" class="${currentClass}">
						<svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg>
						<span>${thisName}</span></a></li>`;

					if($map.indexOf(allHref) !== -1) {
						$(`.js-categoryList[data-cat="${thisParentsCat}"]`).find('.js-category-prodAll').addClass(a);
						$(`.js-categoryList[data-cat="${thisParentsCat}"]`).prev('.prod-menuBlock-head').addClass(a);
						$(`.js-categoryList[data-cat="${thisParentsCat}"]`).slideDown();
					} else {
						$(`.js-categoryList[data-cat="${thisParentsCat}"]`).find('.js-category-prodAll').attr('href', allHref);
					}
					$(`.js-categoryList[data-cat="${thisParentsCat}"]`).append(thisHTML);

				};
			}
		});
		// ブランドリスト生成
		getJSONbrand().then((data) => {
			if (data.rt_bn_brand_list.length) {
				let brandData = data.rt_bn_brand_list;
				for(let i = 0; i < brandData.length; i++) {
					let thisHref = brandData[i].rt_cf_pb_href.href;
					let thisName = brandData[i].cf_pb_name;
					let currentClass = '';

					if($map.indexOf(thisHref) !== -1) {
						currentClass = a;
						$('.js-brandList').prev('.prod-menuBlock-head').addClass(a);
						$('.js-brandList').slideDown();
					}
					let thisHTML = `<li class="prod-menuBlock-subList-li"><a href="${thisHref}" class="${currentClass}">
						<svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg>
						<span>${thisName}</span></a></li>`
					$('.js-brandList').append(thisHTML);
				}
			}
		});
		// シーンリスト生成
		getJSONscene().then((data) => {
			if (data.rt_bn_scene_list.length) {
				let sceneData = data.rt_bn_scene_list;
				for(let i = 0; i < sceneData.length; i++) {
					let thisHref = sceneData[i].rt_cf_ps_href.href;
					let thisName = sceneData[i].cf_ps_name;
					let currentClass = '';

					if($map.indexOf(thisHref) !== -1) {
						currentClass = a;
						$('.js-sceneList').prev('.prod-menuBlock-head').addClass(a);
						$('.js-sceneList').slideDown();
					}
					let thisHTML = `<li class="prod-menuBlock-subList-li"><a href="${thisHref}" class="${currentClass}">
						<svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg>
						<span>${thisName}</span></a></li>`;
					$('.js-sceneList').append(thisHTML);
				}	
			}
		});

		// 限定商品カレント
		$('.js-limiteditemList .prod-menuBlock-subList-li a').each((idx,ele) => {
			if($map.indexOf($(ele).attr('href')) !== -1) {
				$(ele).addClass(a);
				$('.js-limiteditemList').prev('.prod-menuBlock-head').addClass(a);
				$('.js-limiteditemList').slideDown();
			}
		});
		// 子カテゴリ一覧ページ
		$('.js-categoryList').each((idx,ele) => {
			let thisCat = $(ele).attr('data-cat');
			if($map === `/product/category/${thisCat}.html`) {
				$(ele).prev('.prod-menuBlock-head').addClass(a);
				$(ele).slideDown();
			}
		});
		// ブランド一覧ページ
		if($map === '/product/brand/' || $map === '/product/brand/index.html') {
			$('.js-brandList').prev('.prod-menuBlock-head').addClass(a);
			$('.js-brandList').slideDown();
		}
	};

	// <商品一覧>
	const prodListMore = () => {
		const $prodList = $('.js-prodList li');
		if($prodList.length) {
			let startCnt = 0, endCnt = 30;
			const addResult = () => {
				for(let i=startCnt; i<endCnt; i++) {
					if($prodList.eq(i).length) {
						$prodList.eq(i).addClass(v);
						$('.js-prodList-more').addClass(v)
					} else {
						$('.js-prodList-more').remove();
						break;
					}
				}
			};
			// 最初の10件表示
			addResult();
			if($prodList.length <= 20) { $('.js-prodList-more').remove(); }
			// moreボタン押下で10件ずつ追加表示
			$('.js-prodList-more').on('click', () => {
				startCnt += 10; endCnt += 10;
				addResult();
			});
		}
	};

	const productImglazyLoad = () => {
		document.addEventListener("DOMContentLoaded", function () {
			var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = entry.target;
							lazyImage.src = lazyImage.dataset.src;
							if (typeof lazyImage.dataset.srcset === "undefined") {
							} else {
								lazyImage.srcset = lazyImage.dataset.srcset;
							}
							lazyImage.classList.remove("lazy");
							if(lazyImage.classList.contains("lazy-img")) {
								lazyImage.addEventListener("load", function () {
									let wrapElm = getClosest(lazyImage, "figure.lazy-imgWrap");
									wrapElm.classList.add("is-loaded");
								});
							}
							lazyImageObserver.unobserve(lazyImage);
						}
					});
				}, { rootMargin: "50px" });

				lazyImages.forEach(function (lazyImage) {
					lazyImageObserver.observe(lazyImage);
				});

			} else {
				// Possibly fall back to a more compatible method here
			}
			function getClosest(node, selector) {
				return (node.closest || function (_selector) {
					do {
						if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
							return node;
						}
						node = node.parentElement || node.parentNode;
					} while (node !== null && node.nodeType === 1);

					return null;
				}).call(node, selector);
			}
		});
	};

	// <アレルギー検索>
	const allergieSearch = () => {
		const $clear = $('.js-prodSearch-clear');
		const $form = $('.js-prodSearch-form');

		// ラジオボタン
		$('.js-prodSearch-radio[checked="checked"]').parents('.mod-radio').addClass(a);
		$('.js-prodSearch-radio').on('change', (e) => {
			let $this = $(e.currentTarget);
			$('.mod-radio').removeClass(a);
			$this.parents('.mod-radio').addClass(a);
		})
		// チェックボックス
		$('.mod-check-input').on('change', (e) => {
			let $this = $(e.currentTarget);
			$this.parent('.mod-check').toggleClass(a);
		});

		// 検索条件クリア
		$clear.on('click', (e) => {
			$form.find('.mod-check-input').prop('checked', false);
			$('.js-prodSearch-radio').prop('checked', false);
			$('.mod-radio').removeClass(a);
			$('.mod-radio[for="menu1"]').addClass(a).find('.js-prodSearch-radio').prop('checked', true);
		});

		// （ロード時）パラメータの値をform内に反映
		let paramArr = location.search.substring(1).split('&');
		for(let i=0; i<paramArr.length; i++){
			let $thisName = paramArr[i].split('=')[0];
			let $thisVal = paramArr[i].split('=')[1];
			if($thisVal !== 'X') {
				$('.mod-check-input[name="'+ $thisName +'"]').prop('checked', true).parent('.mod-check').addClass(a);
			}
			if($thisName === 'menu') {
				$('.mod-radio').removeClass(a);
				$('.js-prodSearch-radio').prop('checked', false);
				$('.mod-radio[for="'+ $thisVal +'"]').addClass(a).find('.js-prodSearch-radio').prop('checked', true);
			}
		}
		


		// 「以下の原材料をすべて含まない」と「以下の原材料を含む」でaction書き換え
		$('.js-prodSearch-btn').on('click', (e) => {
			let menu = $('.mod-radio.is-active').find('.js-prodSearch-radio').val();
			let paramArr = [];
			let $action = '/product/search/allergie/';
			if(menu === 'menu1') {
				$('.mod-check-input').each((idx,ele) => {
					if($(ele).prop('checked') === true) {
						paramArr.push($(ele).attr('name') +'=0');
					}
				});
				$action += '?'+ paramArr.join('&') + '&menu=menu1';
			} else {
				$('.mod-check-input').each((idx,ele) => {
					if($(ele).prop('checked') === true) {
						paramArr.push($(ele).attr('name') +'=1');
					} else {
						paramArr.push($(ele).attr('name') +'=X');
					}
				});
				$action += 'index2.html?'+ paramArr.join('&') + '&menu=menu2';
			}
			location.href = $action;
		});

	}

	// <キーワード検索>
	const prodSearchKeyword = () => {
		let param = location.search.split('=')[1];
		let thisKeyword = decodeURIComponent(param);
		if(thisKeyword !== '') {
			// $('.js-prodMenuBlock').addClass(a);
			// $('.js-prodMenu-open').addClass(h);
			$('.js-keyword').val(thisKeyword);
			$('.js-keyword-text').text(thisKeyword);
		}
	}

	// <商品カテゴリ>ブランドバナースライド(SP)
	const brandSliderSetting = () => {
		let width = $(window).width();
		if(width < BOURBON.va.device.desktop) {
			$('.prod-brandsite-slider').not('.slick-initialized').slick({
				infinite: true,
				speed: 1500,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: 3,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
			});
		} else {
			$('.prod-brandsite-slider.slick-initialized').slick('unslick');
		}
	}

	// <商品詳細>商品画像スライド
	const prodDetailSlider = () => {
		// 2～3枚目画像がない場合は非表示
		$('.prod-detail-slider-img').each((idx,ele) => {
			if(!$(ele).find('img').length) {
				$(ele).parents('li').remove();
			}
		});

		$('.prod-detail-slider').slick({
			infinite: true,
			speed: 1500,
			// autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 1,
			arrows: false,
			dots: true,
			customPaging: function(slick,index) {
				let targetImage = slick.$slides.eq(index).find('img').attr('src');
				let targetImageAlt = slick.$slides.eq(index).find('img').attr('alt');
				return '<img src="'+ targetImage +'" alt="'+ targetImageAlt +'"/>';
			},
			responsive: [
				{
					breakpoint: 768,
					settings: {
						customPaging: function(slick,index) {
							return false;
						}
					}
				}
			]
		});

	}
	// <商品詳細>ピックアップスライド(sp)
	const topicksSliderSetting = () => {
		let width = $(window).width();
		if(width < BOURBON.va.device.desktop) {
			$('.prod-detail-topicks-slider').not('.slick-initialized').slick({
				infinite: true,
				speed: 1500,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: 2,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
			});
		} else {
			$('.prod-detail-topicks-slider.slick-initialized').slick('unslick');
		}
	}

	// <商品詳細>ピックアップ
	const detailPickUP = () => {
		let $map = location.pathname.split('/');
		let thisBrand = $('.rt_para_brand_id').text();
		let thisCategory = $('.rt_para_category_l_id').text();
		let brandNumArr = [];
		let categoryNumArr = [];
		let thisProdId = $map[$map.length -1].replace('.html', '');

		// ブランド
		if($('.rt_para_brand_id').length) {
			getJSONbrandProdList(thisBrand).then((data) => {
				if (data.rt_bn_product_list.length) {
					let thisData = data.rt_bn_product_list; 
					for(let i = 0; i < thisData.length; i++) {
						if(thisData[i]._key !== thisProdId) {
							brandNumArr.push(i);
						}
					}
					let shuffledArr = brandNumArr.sort(() => 0.5 - Math.random());
					let selectedArr = shuffledArr.slice(0, 5);
					for(let i = 0; i < selectedArr.length; i++) {
						let thisNum = selectedArr[i];
						let thisHref = thisData[thisNum].rt_cf_p_href.href;
						let thisName = thisData[thisNum].rt_cf_p_product_name.content[0];
						let thisImg = '/images/dummy/news_small.jpg';
						let newHTML = '';
						if(thisData[thisNum].rt_cf_p_thumb_img !== null) {
							thisImg = thisData[thisNum].rt_cf_p_thumb_img.src;
						}
						if(thisData[thisNum].rt_product_is_new !== null) {
							newHTML = '<img src="/images/product/icon_new.png" alt="NEW" class="mod-boxLink01-new">';
						}
						let thisHTML = `<li class="pure-u-1-5 pure-u-lg-1-2">
							<a href="${thisHref}" class="mod-boxLink01-a" data-mh="pickup">
								${newHTML}
								<figure class="mod-boxLink01-img">
									<img src="${thisImg}" alt="${thisNum}">
								</figure>
								<p class="mod-boxLink01-name">${thisName}</p>
							</a></li>`;
						$('.js-pickup-brand').append(thisHTML);
					}
				}
			});
		}
		// カテゴリ
		if($('.rt_para_category_l_id').length) {
			getJSONcategoryProdList(thisCategory).then((data) => {
				if (data.rt_bn_product_list.length) {
					let thisData = data.rt_bn_product_list;
					for(let i = 0; i < thisData.length; i++) {
						if(thisData[i]._key !== thisProdId) {
							categoryNumArr.push(i);
						}
					}
					let shuffledArr = categoryNumArr.sort(() => 0.5 - Math.random());
					let selectedArr = shuffledArr.slice(0, 5);
					for(let i = 0; i < selectedArr.length; i++) {
						let thisNum = selectedArr[i];
						let thisHref = thisData[thisNum].rt_cf_p_href.href;
						let thisName = thisData[thisNum].rt_cf_p_product_name.content[0];
						let thisImg = '/images/dummy/news_small.jpg';
						let newHTML = '';
						if(thisData[thisNum].rt_cf_p_thumb_img !== null) {
							thisImg = thisData[thisNum].rt_cf_p_thumb_img.src;
						}
						if(thisData[thisNum].rt_product_is_new !== null) {
							newHTML = '<img src="/images/product/icon_new.png" alt="NEW" class="mod-boxLink01-new">';
						}

						let thisHTML = `<li class="pure-u-1-5 pure-u-lg-1-2">
							<a href="${thisHref}" class="mod-boxLink01-a" data-mh="pickup">
							${newHTML}
								<figure class="mod-boxLink01-img">
									<img src="${thisImg}" alt="${thisNum}">
								</figure>
								<p class="mod-boxLink01-name">${thisName}</p>
							</a></li>`;
						$('.js-pickup-category').append(thisHTML);
					}
				}
			});
		}
	};
	
	// ＜商品詳細＞お気に入り商品かチェック
	const checkFavo = (_thisProdCode) => {
		for(let item in localStorage) {
			if(item.indexOf('bourbon-favItem-') !== -1) {
				if(item.replace(/bourbon-favItem-/, '') === _thisProdCode) {
					return true;
				}
			}
		}
		return false;
	};
	// ＜商品詳細＞お気に入りに追加,削除	
	const toggleFav = () => {
		let $map = BOURBON.va.pathname.split('/');
		let prodID = $map[$map.length -1].split('.')[0];
		// お気に入り商品にアイコン点灯
		let flgFavo = checkFavo(prodID);
		if(flgFavo) {
			$('.js-favBtn').addClass(a);
		} else {
			$('.js-favBtn').removeClass(a);
		}

		$('.js-favBtn').on('click', (e) => {
			let $this = $(e.currentTarget);
			if(!$this.hasClass(a)) {
				let favoDatetime = new Date();
				favoDatetime = favoDatetime.toLocaleString();
				localStorage.setItem('bourbon-favItem-' + prodID, favoDatetime);
				$this.addClass(a);
			} else {
				localStorage.removeItem('bourbon-favItem-' + prodID);
				$this.removeClass(a);
			}
		});
	};

	// ＜お気に入りリスト＞localStorageからお気に入りリスト取得&描画
	const getFavoList = () => {
		let favoStorage = [];
		let favArr = [];
		let itemParamArr = [];

		for(let i in localStorage) {
			if(i.indexOf('bourbon-favItem-') !== -1) {
				favoStorage.push(i);
			}
		}
		for(let i = 0; i < favoStorage.length; i++) {
			let hash = {
				name: favoStorage[i],
				datetime: localStorage[favoStorage[i]]
			};
			favArr.push(hash);
		}

		// お気に入り登録日が新しい順にソート
		favArr.sort(
			function(x, y){
				let xDate = x['datetime'];
				let yDate = y['datetime'];
				if(xDate > yDate) return-1;
				if(xDate < yDate) return 1;
				return 0;
			}
		);
		if(favArr.length > 0) {
			for(let i=0; i<favArr.length; i++){
				let $thisID =  favArr[i].name.replace(/bourbon-favItem-/, '');
				getJSONprodData($thisID).then((data) => {
					if(data.rt_bn_product_detail.length) {
						let newHTML = '';
						let mailOrderHTML = '';
						let tvcmHTML = '';
						let businessHTML = '';
						let areaLimitedHTML = '';
						let timeLimitedHTML = '';
						let preSaleHTML = '';
						let limitedHTML = '';

						let prodData = data.rt_bn_product_detail[0];
						let thisName = prodData.rt_cf_p_product_name.content[0];
						let thisUrl = prodData.rt_cf_p_href.href;
						let thisImg = prodData.rt_cf_p_thumb_img.src;
						// NEWマーク
						let thisNew = prodData.rt_product_is_new;
						if(thisNew !== null) {
							if(thisNew.content === 'true') {
								newHTML = '<img src="/images/product/icon_new.png" alt="NEW" class="mod-boxLink01-new">';
							}
						}
						// 通信販売限定
						let thisMailOrder = prodData.rt_cf_p_mail_order;
						if(thisMailOrder !== null) {
							mailOrderHTML = '<span class="mod-boxLink01-tag">通信販売限定</span>';
						}
						// TV CM
						let thisTVCM = prodData.rt_cf_p_tvcm;
						if(thisTVCM !== null) {
							tvcmHTML = '<span class="mod-boxLink01-tag">TV CM</span>';
						}
						// 業務用商品
						let thisBusiness = prodData.rt_cf_p_for_business
						if(thisBusiness !== null) {
							businessHTML = '<span class="mod-boxLink01-tag">業務用商品</span>';
						}
						// 地域限定（接頭語あり）
						let areaLimited = prodData.rt_cf_p_area_limited;
						if(areaLimited !== null) {
							let areaName = '';
							if(areaLimited.prefix !== null) {
								areaName = areaLimited.prefix;
							}
							areaLimitedHTML = `<span class="mod-boxLink01-tag">${areaName}${areaLimited.content}</span>`;
						}
						// 期間限定（接頭語あり）
						let timeLimited = prodData.rt_cf_p_time_limited;
						if(timeLimited !== null) {
							let timeName = '';
							if(timeLimited.prefix !== null) {
								timeName = timeLimited.prefix;
							}
							timeLimitedHTML = `<span class="mod-boxLink01-tag">${timeName}${timeLimited.content}</span>`;
						}
						// 先行発売（接頭語あり）
						let preSale = prodData.rt_cf_p_pre_sale;
						if(preSale !== null) {
							let saleName = '';
							if(preSale.prefix !== null) {
								saleName = preSale.prefix;
							}
							preSaleHTML = `<span class="mod-boxLink01-tag">${saleName}${preSale.content}</span>`;
						}
						// 限定（接頭語あり）
						let thisLimited = prodData.rt_cf_p_limited;
						if(thisLimited !== null) {
							let limitedName = '';
							if(thisLimited.prefix !== null) {
								limitedName = thisLimited.prefix;
							}
							limitedHTML = `<span class="mod-boxLink01-tag">${limitedName}${thisLimited.content}</span>`;
						}

						let favHTML = `<li class="pure-u-1-5 pure-u-lg-1-2" style="order:${i}"">
						<a href="${thisUrl}" class="mod-boxLink01-a">
						${newHTML}
						<figure class="mod-boxLink01-img">
							<img src="${thisImg}" alt="${thisName}">
						</figure>
						<div class="mod-boxLink01-tagList">
							${mailOrderHTML}${areaLimitedHTML}${timeLimitedHTML}
							${tvcmHTML}${preSaleHTML}${businessHTML}${limitedHTML}
						</div>
						<p class="mod-boxLink01-name">${thisName}</p></a></li>`;

						$('.js-favList').append(favHTML);
					}
				});
			};
		} else {
			$('.js-favList').remove();
		}
	};

	// <商品詳細>アレルギー表示
	const allergieTextTrim = () => {
		if($('.js-allergie-td').length) {
			let allergieItem = $('.js-allergie-td').find('span').not(':empty');
			allergieItem.each((idx,ele) => {
				if(idx === allergieItem.length -1) {
					let thisText = $(ele).text();
					$(ele).text(thisText.replace('、', ''));
				}
			});
		}
	};

	// --------------------------------------------------------------------------------
	// 商品TOP
	if($('.prod-idx-newProd-slider').length) {
		newProductsSlider();
	}
	if($('.prod-idx-brand-slider').length) {
		brandSlider();
	}
	if($('.prod-idx-campaign-slider').length) {
		campaignSlider();
	}
	// 商品配下共通
	if($('.js-prodMenuBlock').length) {
		window.onload = () => {
			prodMenu();
			sideNav();
		}
	}
	// キーワード検索
	if(location.pathname === '/product/search/keyword/') {
		prodSearchKeyword();
	}
	if($('.prod-brandsite-slider').length) {
		$(window).resize(function(){
			brandSliderSetting();
		});
	}

	// 商品一覧
	prodListMore();
	productImglazyLoad();

	// アレルギー検索
	if(BOURBON.va.pathname === '/product/allergie/' || BOURBON.va.pathname === '/product/allergie/index.html' ||
	BOURBON.va.pathname === '/product/search/allergie/' || BOURBON.va.pathname === '/product/search/allergie/index.html' ||
	BOURBON.va.pathname === '/product/search/allergie/index2.html') {
		allergieSearch();
	}
	// 商品詳細
	if($('.prod-detail').length) {
		detailPickUP();
		toggleFav();
		allergieTextTrim();
		prodDetailSlider();
		$(window).resize(function(){
			topicksSliderSetting();
		});
	}
	// お気に入りリスト
	if(BOURBON.va.pathname === '/product/favorite.html') {
		getFavoList();
	}
})(window.jQuery, window.BOURBON);
